// Categorized micro-actions for the library.
// 4 categories: declutter, movement, digital_detox, creativity
export const MICRO_ACTION_CATEGORIES = [
  { id: "declutter", label: "Declutter", icon: "Sparkles", description: "Small physical clearing" },
  { id: "movement", label: "Movement", icon: "Activity", description: "Light physical actions" },
  { id: "digital_detox", label: "Digital Detox", icon: "Smartphone", description: "Step away from screens" },
  { id: "creativity", label: "Creativity & Hobby", icon: "Palette", description: "Tend to your craft" },
];

export const MICRO_ACTIONS = [
  // Declutter
  { id: 1, category: "declutter", title: "Clear one surface", body: "Pick one shelf, table, or counter. Spend 3 minutes returning what doesn't belong." },
  { id: 2, category: "declutter", title: "One inbox sweep", body: "Archive or delete 10 emails. Don't reply, don't read deeply — just clear." },
  { id: 3, category: "declutter", title: "Empty one bag or pocket", body: "Empty a bag, drawer, or jacket pocket you've been ignoring. Sort: keep, toss, return." },
  { id: 4, category: "declutter", title: "5-thing toss", body: "Find 5 small things you no longer need. Bag them. Decide later." },

  // Movement
  { id: 5, category: "movement", title: "10 slow shoulder rolls", body: "Roll backward 5 times, forward 5 times. Notice where your shoulders settle when you stop." },
  { id: 6, category: "movement", title: "Walk to the window", body: "Stand up. Walk to the nearest window. Look at the farthest thing you can see for 60 seconds." },
  { id: 7, category: "movement", title: "Stretch your hips", body: "Stand and reach for your toes. Hold 20 seconds. Stand up slowly. Repeat once." },
  { id: 8, category: "movement", title: "2-minute stairs", body: "Find stairs. Walk up and down for two minutes. Mind the breath, not the speed." },

  // Digital Detox
  { id: 9, category: "digital_detox", title: "Phone in another room", body: "Place your phone in another room for 30 minutes. Notice the urge — let it pass without acting." },
  { id: 10, category: "digital_detox", title: "Mute one noisy app", body: "Open notification settings. Mute the app that pulls you most often. You can unmute later." },
  { id: 11, category: "digital_detox", title: "Eat one meal screen-free", body: "No phone, no TV, no laptop. Just the meal in front of you. Notice the first three bites." },
  { id: 12, category: "digital_detox", title: "10-minute walk, no phone", body: "Leave the phone behind. Walk ten minutes. Notice three things you usually miss." },

  // Creativity & Hobby
  { id: 13, category: "creativity", title: "5 minutes of your craft", body: "Pick the hobby you've been postponing. Spend exactly 5 minutes on it. No outcome required." },
  { id: 14, category: "creativity", title: "Listen to one full song", body: "Pick a song you love. Sit and listen — no scrolling, no second screen. Just the song." },
  { id: 15, category: "creativity", title: "Write one sentence", body: "Open a notebook. Write a single sentence about how today actually feels. Close the notebook." },
  { id: 16, category: "creativity", title: "Sketch one shape", body: "Draw a single shape — circle, square, leaf. Don't aim for art. Aim for presence." },
];

export function getActionsByCategory(categoryId) {
  return MICRO_ACTIONS.filter((a) => a.category === categoryId);
}

// Pick today's micro-action (rotates daily) — for Free users.
export function getTodaysMicroAction() {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const diff = now - start;
  const dayOfYear = Math.floor(diff / (1000 * 60 * 60 * 24));
  return MICRO_ACTIONS[(dayOfYear + 3) % MICRO_ACTIONS.length];
}
